import * as React from 'react'
import { Container } from 'components/Layout'
import * as sText from 'components/Text/Text.scss'
import { VoiceCreateForm } from 'features/Voices/VoiceCreateForm'
import HeadingBanner from 'components/Text/HeadingBanner'
import cn from 'classnames'

export interface IVoiceCreateModalProps {
  modalCancel: () => undefined
  talentID?: string
}
export class VoiceCreateModal extends React.Component<IVoiceCreateModalProps> {
  state = {
    headings: {
      heading: 'Create Recording',
      subHeading: 'Select from hundreds of voice actors',
    },
  }

  setHeadings = headings => {
    this.setState({ headings })
  }

  render() {
    const { modalCancel, talentID } = this.props

    const {
      headings: { heading, subHeading },
    } = this.state

    return (
      <div>
        <HeadingBanner filled>
          <h3 className={cn(sText.heading3, sText.accent)}>{heading}</h3>
          <div className={sText.descrip2}>{subHeading}</div>
        </HeadingBanner>

        <Container paddingTop paddingBottom className="sm">
          <VoiceCreateForm
            talentID={talentID}
            onCancel={modalCancel}
            setHeadings={this.setHeadings}
          />
        </Container>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Voices/VoiceCreateModal/VoiceCreateModal.tsx